import { render, staticRenderFns } from "./dcPxWjCatList.vue?vue&type=template&id=fc216470&scoped=true&"
import script from "./dcPxWjCatList.vue?vue&type=script&lang=js&"
export * from "./dcPxWjCatList.vue?vue&type=script&lang=js&"
import style0 from "./dcPxWjCatList.vue?vue&type=style&index=0&id=fc216470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc216470",
  null
  
)

export default component.exports